import { render, staticRenderFns } from "./invoices-list.vue?vue&type=template&id=12ab20be&scoped=true&"
import script from "./invoices-list.vue?vue&type=script&lang=js&"
export * from "./invoices-list.vue?vue&type=script&lang=js&"
import style0 from "./invoices-list.vue?vue&type=style&index=0&id=12ab20be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab20be",
  null
  
)

export default component.exports